import styled from 'vue-styled-components';

const linkProps = {

};


const styledLink = styled('a', linkProps)`
  text-decoration: none;
  color: ${props => props.theme.primaryColor};

  &:visited, &:hover {
    color: ${props => props.theme.primaryColor};
  }
`;

export { styledLink as default };
